const env = process.env || {};

const localS3HostIp = env.VUE_APP_LOCAL_S3_HOST_IP as string;
const localS3Port = (env.VUE_APP_LOCAL_S3_PORT as string) || '9000';

export const LOCAL_S3_ENDPOINT =
    (env.VUE_APP_LOCAL_S3_ENDPOINT as string) ||
    (localS3HostIp ? `http://${localS3HostIp}:${localS3Port}` : 'http://localhost:9000');
export const LOCAL_S3_BUCKET =
    (env.VUE_APP_LOCAL_S3_BUCKET as string) || 'test-discoverystudies';
export const LOCAL_S3_PREFIX =
    (env.VUE_APP_LOCAL_S3_PREFIX as string) || 'demopattern';
export const LOCAL_S3_ACCESS_KEY =
    (env.VUE_APP_LOCAL_S3_ACCESS_KEY as string) || 'minioadmin';
export const LOCAL_S3_SECRET_KEY =
    (env.VUE_APP_LOCAL_S3_SECRET_KEY as string) || 'minioadmin123';
export const LOCAL_S3_REGION =
    (env.VUE_APP_LOCAL_S3_REGION as string) || 'us-east-1';

// Only enable local S3 when explicitly set to 'true'. Default false so production APKs
// (where env may be unset) use the download domain from the language file, not localhost.
export const LOCAL_S3_ENABLED =
    (env.VUE_APP_LOCAL_S3_ENABLED as string)?.toLowerCase() === 'true';

const normalizedEndpoint = LOCAL_S3_ENDPOINT.replace(/\/+$/g, '');
export const LOCAL_S3_BASE_URL = `${normalizedEndpoint}/${LOCAL_S3_BUCKET}/${LOCAL_S3_PREFIX}`;
